import { z } from "zod";

export const tgWidgetPayloadSchema = z.object({
  id: z.number(),
  first_name: z.string(),
  last_name: z.string().optional(),
  username: z.string().optional(),
  photo_url: z.string().optional(),
  auth_date: z.number(),
  hash: z.string(),
});

export const lkLoginResponseSchema = z.object({
  ok: z.boolean(),
  user_id: z.string(),
});

export const adminLoginResponseSchema = z.object({
  ok: z.boolean(),
  user_id: z.string(),
  totp_required: z.boolean(),
  totp_enabled: z.boolean(),
});

export const totpSetupResponseSchema = z.object({
  secret: z.string(),
  provisioning_uri: z.string(),
});

export const totpVerifyRequestSchema = z.object({
  code: z.string().regex(/^\d{6}$/),
});
